import type { SVGProps } from "react";

import { forwardRef } from "react";

export const LogoMini = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg
    ref={ref}
    fill="currentColor"
    height="1em"
    viewBox="0 0 284 83"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M82.306.166v2.119L47.153 41.105l35.153 38.822v2.119H64.235L33.6 48.729H15.246v33.318H0V.166h15.246v33.318H33.6L64.235.166h18.071zM193.907.166l-45.177 81.88h-15.246L88.307.167h17.646l35.154 64.66L176.4.166h17.507zM283.194 18.52v63.527h-15.245V18.52c0-1.693-1.411-3.104-3.104-3.104h-46.588c-1.693 0-3.104 1.411-3.104 3.104v63.527h-15.246V.166h64.942a18.316 18.316 0 0118.355 18.354h-.01z" />
  </svg>
));

LogoMini.displayName = "LogoMini";

export default LogoMini;
